import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_3 = { class: "px-[34px] icon flex justify-center mb-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "flex flex-wrap justify-center gap-2 mb-2 px-[34px]"
}
const _hoisted_6 = { class: "flex h-[34px] items-center justify-center p-2 bg-white rounded-full" }
const _hoisted_7 = { class: "font-sourcesanspro-semibold text-xs2 text-anykrowd-dark" }
const _hoisted_8 = { class: "flex h-[34px] items-center justify-between p-2 bg-white rounded-full" }
const _hoisted_9 = { class: "flex items-center mr-2" }
const _hoisted_10 = { class: "font-sourcesanspro-semibolditalic text-xs2 text-[#707070]" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex items-center mr-2" }
const _hoisted_13 = { class: "font-sourcesanspro-semibold text-xs2 text-anykrowd-dark" }
const _hoisted_14 = {
  id: "popover-button",
  class: "flex items-center justify-center p-2 rounded-full font-sourcesanspro-bold text-xs2 cursor-pointer bg-white"
}
const _hoisted_15 = { class: "mr-2 text-black font-sourcesanspro-regular" }
const _hoisted_16 = { class: "text-white font-sourcesanspro-regular" }

import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { IonButton, IonContent, IonIcon, IonList, IonItem, IonRadio, IonLabel, IonPopover } from '@ionic/vue';
import { chevronBackOutline, linkOutline, chevronDownOutline, shareSocialOutline } from 'ionicons/icons';
import { Share } from '@capacitor/share';
import { useI18n } from 'vue-i18n';

import RfidWalletBox from '@/modules/rfid/components/RfidWalletBox.vue';
import TopBar from '@/shared/components/TopBar.vue';
import useRfidGuest from '@/modules/rfid/composables/useRfidGuest';
import useUserProfile from '@/modules/profile/composables/useUserProfile';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import useTenant from '@/shared/composables/useTenant';
import router from '@/router';
import useUtils from '@/shared/composables/useUtils';
import useStorageService from '@/shared/composables/useStorageService';
import useToast from '@/shared/composables/useToast';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'RfidGuestPage',
  setup(__props) {

const { t, locale } = useI18n();
const assetStore = useAssetsStore();

const route = useRoute();
const encryptedRfidTag = route.params.id?.toString?.() || '';
const isSharedLink = route.query.share === 'true';
const { searchRfidTag, saveGuestWalletBox } = useRfidGuest();
const { isSuccessRfidTag, rfidTag, rfidTagMutate } = searchRfidTag();
const { getUserProfile } = useUserProfile();
const { userProfile } = getUserProfile();
const continueLinking = ref(false);
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();
const { getAppLanguages } = useUtils();
const selectedAppLanguage = ref('');
const appLanguages = ref(getAppLanguages());
const { set, get } = useStorageService();
const selectedAppLanguageObject = ref();
const { presentToast } = useToast();

// Share wallet function for guest RFID mode
const shareGuestWallet = async () => {
	try {
		if (encryptedRfidTag) {
			await Share.share({
				url: `${window.location.origin}/#/guest-topup/${encryptedRfidTag}`,
			});
		}
	} catch (error: any) {
		if (error && error.message && error.message !== 'Share canceled') {
			await presentToast('top', error, 5000, 'danger');
		}
	}
};

onMounted(async () => {
	if (encryptedRfidTag) {
		rfidTagMutate({ encrypted_rfid_tag: encryptedRfidTag });
	}
	if (route.query.continueLinking) {
		continueLinking.value = true;
	}

	const appLanguage = await get('app_language');

	// Set app language if it exists in storage
	if (appLanguage) {
		selectedAppLanguage.value = appLanguage;
		selectedAppLanguageObject.value = appLanguages.value.find((lang) => lang.value === appLanguage);
	} else {
		// Otherwise, set default app language
		selectedAppLanguage.value = locale.value;
		selectedAppLanguageObject.value = appLanguages.value.find((lang) => lang.value === locale.value);
	}
});

const goTo = async (link: string) => {
	await router.push(link);
};

watch(
	[rfidTag, isSuccessRfidTag],
	async ([tag, success]) => {
		if (tag && typeof tag === 'object' && tag.id !== undefined && success && tenantConfig.value?.enable_full_guest_mode && tenantConfig.value?.enable_guest_mode_full_access) {
			await saveGuestWalletBox(tag, encryptedRfidTag, success, continueLinking.value, true);
			if (tenantConfig.value?.enable_full_guest_mode && tenantConfig.value?.enable_guest_mode_full_access) {
				goTo('/dashboard');
			}
		}
	},
	{ immediate: false },
);

watch(selectedAppLanguage, (newValue) => {
	if (newValue) {
		locale.value = newValue;
		set('app_language', newValue);
		appLanguages.value = getAppLanguages();
		selectedAppLanguageObject.value = appLanguages.value.find(lang => lang.value === newValue);
	}
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonButton), {
              class: "w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "flex items-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(chevronBackOutline),
                      class: "ion-no-padding ion-no-margin text-black mr-[2px]"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(isSharedLink ? _unref(t)('guest_top_up.title') : _unref(t)('rfid.guest.dashboard')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(assetStore).logoUrl,
            class: "max-w-[70%]"
          }, null, 8, _hoisted_4)
        ]),
        (_unref(rfidTag) && !isSharedLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: `/wallet/history?id=${_unref(encryptedRfidTag)}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('components.rfid_wallet_box.history')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(linkOutline),
                      class: "text-anykrowd-dark text-[#707070]"
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('components.rfid_wallet_box.rfid_linked')), 1)
                ])
              ]),
              (_unref(tenantConfig)?.guest_wallet_topup_clientx)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "flex h-[34px] items-center justify-between p-2 bg-white rounded-full cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (shareGuestWallet()))
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(shareSocialOutline),
                          class: "text-anykrowd-dark text-[#707070]"
                        }, null, 8, ["icon"])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('guest_top_up.share.title')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(IonLabel), { class: "flex items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([selectedAppLanguageObject.value?.flagClass, "mr-2"]),
                        style: {"width":"1.5em","height":"1em"}
                      }, null, 2),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)(selectedAppLanguageObject.value?.label)), 1),
                      _createVNode(_unref(IonIcon), {
                        class: "text-anykrowd-dark",
                        icon: _unref(chevronDownOutline)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(IonPopover), {
                  trigger: "popover-button",
                  "dismiss-on-select": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonContent), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonList), null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appLanguages.value, (language) => {
                              return (_openBlock(), _createBlock(_unref(IonItem), {
                                key: language.value,
                                class: _normalizeClass(["text-white font-sourcesanspro-regular cursor-pointer", { 'selected': selectedAppLanguage.value === language.value }]),
                                lines: "none",
                                onClick: ($event: any) => (selectedAppLanguage.value = language.value)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonRadio), {
                                    value: language.value,
                                    checked: selectedAppLanguage.value === language.value,
                                    class: "mr-4"
                                  }, null, 8, ["value", "checked"]),
                                  _createVNode(_unref(IonLabel), { class: "flex items-center" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([language.flagClass, "mr-2"]),
                                        style: {"width":"1.5em","height":"1em"}
                                      }, null, 2),
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)(language.label)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(RfidWalletBox, {
          encryptedRfidTag: _unref(encryptedRfidTag),
          isSuccessRfidTag: _unref(isSuccessRfidTag),
          rfidTag: _unref(rfidTag),
          "user-profile": _unref(userProfile),
          "continue-linking": continueLinking.value,
          "is-shared-link": isSharedLink
        }, null, 8, ["encryptedRfidTag", "isSuccessRfidTag", "rfidTag", "user-profile", "continue-linking"])
      ])
    ]),
    _: 1
  }))
}
}

})